module.exports = __webpack_public_path__ + "img/education3.1f64879f.svg";